var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "board-search-wrap"
  }, [_c('v-row', {
    staticClass: "row--xs search--primary"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "select-box",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-select', {
    staticClass: "v-input--small w-100 w-md-120px",
    attrs: {
      "items": _vm.searchKeys,
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    staticClass: "search-box",
    attrs: {
      "md": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "v-input--small w-100 w-md-260px",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "placeholder": "검색어를 입력하세요."
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    staticClass: "search-btn",
    attrs: {
      "cols": "auto"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    }
  }, [_vm._v("검색")])], 1)], 1)], 1), _c('table', {
    staticClass: "board-list"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.notifications, function (notification) {
    return _c('tr', {
      key: notification._id,
      on: {
        "click": function click($event) {
          return _vm.$router.push("/service/notice/".concat(notification._id));
        }
      }
    }, [_c('td', {
      staticClass: "board-list__tit"
    }, [_c('div', {
      staticClass: "text-truncate"
    }, [_c('span', [_vm._v(" " + _vm._s(notification === null || notification === void 0 ? void 0 : notification.subject) + " ")])])]), _c('td', {
      staticClass: "board-list__txt"
    }, [_vm._v(" 관리자 ")]), _c('td', {
      staticClass: "board-list__txt"
    }, [_vm._v(" " + _vm._s(_vm.$dayjs(notification === null || notification === void 0 ? void 0 : notification.createdAt).format("YYYY-MM-DD")) + " ")]), _c('td', {
      staticClass: "board-list__txt"
    }, [_vm._v(" " + _vm._s(notification === null || notification === void 0 ? void 0 : notification.viewCount) + " ")])]);
  }), 0)]), _c('pagination-component', {
    attrs: {
      "count": _vm.pageCount
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "d-lg-table-header"
  }, [_c('tr', [_c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "58%"
    }
  }, [_vm._v("제목")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("작성자")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("작성일")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("조회")])])]);
}]

export { render, staticRenderFns }